import { SOCKET_NAME } from '../../definitions';

export class HealthCheck {
  readonly type = HealthCheckTypes.HEALTH_CHECK;
  constructor(public payload: HealthCheckPayload) {}
}

/**
 * Event Types
 */
export enum HealthCheckTypes {
  HEALTH_CHECK = '[Socket] Health Check',
}

export enum SocketInitializedTypes {
  SOCKET_INITIALIZED = '[Socket] Socket Initialized',
  SOCKET_INITIALIZATION_FAILED = '[Socket] Socket Initialization Failed',
}

export enum SocketErrorTypes {
  AUTHENTICATION_FAILED = '[Socket] Socket Authentication Failed',
  AUTHENTICATION_EXPIRED = '[Socket] Socket Authentication Expired',
}

/**
 * Payloads
 */
export interface HealthCheckPayload {
  deviceId: string;
  socketId: string;
  socketName: SOCKET_NAME;
  token: string;
}
export interface SocketInitializedPayload {
  id: string;
  name: SOCKET_NAME;
}
export interface SocketInitializedFailedPayload {
  name: SOCKET_NAME;
  error: any;
}

/**
 * Events
 */
export class SocketInitialized {
  readonly type = SocketInitializedTypes.SOCKET_INITIALIZED;

  constructor(public payload: SocketInitializedPayload) {}
}
export class SocketInitializationFailed {
  readonly type = SocketInitializedTypes.SOCKET_INITIALIZATION_FAILED;

  constructor(public payload: SocketInitializedFailedPayload) {}
}
